import { Navigate, useParams } from "react-router-dom";

/**
 * Handles Universal Link / browser fallback for deep-linked announcements.
 * When a user opens https://hp-chat-web.web.app/announcement/:id in a browser
 * (i.e. the mobile app is not installed), this component redirects them to
 * the home feed with the ?announcement= query param so the card is scrolled
 * into view and highlighted.
 */
export const AnnouncementRedirect = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/?announcement=${id}`} replace />;
};
